import React from "react";
import { useMyContext } from "src/hooks/context";
import { Select } from "antd";
import ReactLoading from "react-loading";
const { Option } = Select;

const formatter = (value) => {
  return value ? value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null;
};

const Detail = () => {
  const { state, dispatch, type } = useMyContext();

  return (
    <div className="w-full  bg-white rounded-lg shadow-lg p-2 mt-2 md:mt-0 md:ml-2 md:w-3/5">
      <div className="w-full text-center font-bold border-b p-3 mb-4 text-md text-white bg-teal-500 rounded-t-md">
        Дэлгэрэнгүй мэдээлэл
      </div>
      <div className="flex flex-col xs:flex-row xs:justify-between gap-2 border p-2 rounded-md shadow-md">
        <div className="w-full xs:w-36">
          <Select
            size="medium"
            style={{ width: "100%" }}
            placeholder="Сонгоно уу"
            optionFilterProp="children"
            value={state?.selectedMonth?.value}
            onChange={(data) =>
              dispatch({ type: type.CHANGE_SELECTED_MONTH, data: data })
            }
          >
            {state.listMonth.map((item, index) => {
              return (
                <Option key={index} value={item?.year + "." + item?.month}>
                  {item?.year + " он " + item?.month + " сар"}
                </Option>
              );
            })}
          </Select>
        </div>
        <div className="flex items-center justify-between xs:justify-end xs:gap-2 w-full overflow-x-auto pb-4">
          {state.tabs.map((item, index) => {
            return (
              <div
                key={index}
                className={
                  "border p-1 shadow-md rounded-md w-20 flex items-center justify-center cursor-pointer text-sm font-medium" +
                  (state?.selectedTab === item?.value
                    ? " bg-gradient-to-r from-cyan-400 to-blue-600 text-white"
                    : "")
                }
                onClick={() =>
                  dispatch({
                    type: type.CHANGE_SELECTED_TAB,
                    data: item?.value,
                  })
                }
              >
                {item?.text}
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full mt-3 shadow-md px-2 rounded-md border overflow-auto">
        {state.loading ? (
          <div className="w-full h-64 items-center justify-center flex flex-column flex-wrap bg-transparent">
            <ReactLoading type="bars" color="teal" />
            <div className="absolute mt-16">
              <h3>Уншиж байна...</h3>
            </div>
          </div>
        ) : (
          <table className="w-full border my-2">
            <thead>
              <tr className="">
                <th className="border text-center p-2">
                  Нэмэгдэл, суутгалын нэр
                </th>
                <th className="border text-center">Нэмэгдэл</th>
                <th className="border text-center">Суутгал</th>
              </tr>
            </thead>
            <tbody className="">
              {state.detailFiltered.map((item, index) => {
                return (
                  <tr key={index} className="">
                    <td className="border text-center p-2 flex">
                      <div className="text-blue-500 mr-2">{item?.code}</div>
                      {item?.description}
                      <div className="ml-1">
                        {item?.total_hours != null && item?.total_hours + "ц/"}
                        {item?.worked_hours != null && item?.worked_hours + "ц"}
                      </div>
                      {item?.month &&
                        // eslint-disable-next-line eqeqeq
                        item?.month != state.selectedMonth.month && (
                          <div className="ml-1">({item?.month} сар) </div>
                        )}
                      {item?.code <= 3 && (
                        <div className="ml-2 text-green-600">
                          {item?.code === 1 && "зэрэг: "}
                          {item?.code === 2 && "цалин: "}
                          {item?.salary}
                        </div>
                      )}
                    </td>

                    <td className="border text-right p-2 text-green-600">
                      {formatter(item?.debit)}
                    </td>
                    <td className="border text-right p-2 text-red-600">
                      {formatter(item?.credit)}
                    </td>
                  </tr>
                );
              })}
              <tr className="font-medium">
                <td className="border text-right p-2">Нийт:</td>
                <td className="border text-right p-2 text-green-600">
                  {formatter(state?.info?.sumDebit)}
                </td>
                <td className="border text-right p-2 text-red-600">
                  {formatter(state?.info?.sumCredit)}
                </td>
              </tr>
              <tr className="font-medium">
                <td className="border text-right p-2">Гарт олгох:</td>
                <td className="border text-right p-2 text-green-600">
                  {formatter(state?.info?.sumDiffrence)}
                </td>
                <td className="border text-right p-2"></td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default React.memo(Detail);
